import { render, staticRenderFns } from "./IconClose.vue?vue&type=template&id=7da8fb99&"
import script from "./IconClose.vue?vue&type=script&lang=js&"
export * from "./IconClose.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports